import { useFormFieldDef } from '@/common/form/hooks/useFormFieldDef';
import { Autocomplete, TextField } from '@mui/material';
import { useMemo } from 'react';

export const TrxColFormField = ({ trxCols, fieldDef }) => {
  const { value, setValue, onBlur, error, helperText, label, disabled } = useFormFieldDef(fieldDef);

  const options = useMemo(() => {
    return trxCols.map((trxCol) => {
      return { label: trxCol };
    });
  }, [trxCols]);

  const selected = useMemo(() => options.find((o) => o.label === value) ?? null, [options, value]);

  return (
    <Autocomplete
      id={fieldDef.displayName}
      disabled={disabled}
      options={options}
      value={selected}
      onChange={(_, newOption) => setValue(newOption?.label ?? null)}
      onBlur={onBlur}
      isOptionEqualToValue={(opt, val) => opt.label === val.label}
      renderOption={(props, option) => <li {...props}>{option.label}</li>}
      renderInput={(params) => <TextField {...params} label={label} error={error} helperText={helperText} />}
    />
  );
};
